import React from "react";
import "../styles/scheduleStyles.css";

function WeekCard({ matches }) {
    return (
        <div className="week-card-container">
            {matches.map((match, index) => (
                <div className="match-card" key={index}>
                    <div className="time-field">
                        {match.time} | Field {match.field}
                    </div>
                    <div className="teams">
                        <div className="home-team">{match.home}</div>
                        <div className="vs">vs</div>
                        <div className="away-team">{match.away}</div>
                    </div>
                    <div className="score">{match.score ? match.score : "-"}</div>
                </div>
            ))}
        </div>
    );
}

export default WeekCard;
